import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../shared/components/Icon/Icon";
import classes from "./Footer.module.scss";

export const Footer: FC = () => {
	const { t } = useTranslation();
	const address = "123 Maple Street, Apartment 4B Los Angeles, CA 90012, USA";
	const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
		address
	)}`;
	return (
		<div className={classes.wrapper}>
			<Icon className={classes.icon} name="logo" size={150} />
			<div className={classes.middle}>
				<h2 className={classes.title}>
					Some final words, that also could be funny but not too much
				</h2>

				<div className={classes.info}>
					<a
						href={mapUrl}
						rel="noreferrer"
						target="_blank"
						className={classes.geo}
					>
						<Icon name="geo" className={classes.icon} />
						<span>
							123 Maple Street, Apartment 4B Los Angeles, CA 90012, USA
						</span>
					</a>

					<a href="email@gmail.com" target="_blank" className={classes.mail}>
						<Icon name="mail" />
						<span>email@gmail.com</span>
					</a>
				</div>

				<div className={classes.icons}>
					<button className={classes.button}>
						<Icon name="discord" size={18} />
					</button>

					<button className={classes.button}>
						<Icon name="telegram" size={18} />
					</button>

					<button className={classes.button}>
						<Icon name="twitter" size={18} />
					</button>

					<button className={classes.button}>
						<Icon name="youtube" size={18} />
					</button>
				</div>
			</div>
			<div className={classes.header}>
				<div className={classes.left}>
					<ul className={classes.links}>
						<li className={classes.text}>{t("translation.header.play")}</li>
						<li className={classes.text}>{t("translation.header.paper")}</li>
						<li className={classes.text}>{t("translation.header.links")}</li>
						<li className={classes.text}>
							<Icon name="cart" />
							{t("translation.header.market")}
						</li>
					</ul>
				</div>
			</div>

			<div className={classes.footer}>
				<div className={classes.created}>
					Created by{" "}
					<a
						target="_blank"
						rel="norefferer noreferrer"
						href="https://xono.one/"
					>
						xono.one
					</a>
				</div>
				<div className={classes.copyright}>
					© Copyright 2023. All rights reserved
				</div>
			</div>
		</div>
	);
};
